import Vetting from '../src/Vetting/index';
export default Vetting;
